export enum MultiArrayLocalizationGroupStatus {
	/** Device connection is successful */
	Connected = 'CONNECTED',
	/** Error connecting to this device */
	ConnectionError = 'CONNECTION_ERROR',
	/** One or more device(s) within the array group is more than 12ft (366 cm) away */
	DevicesTooFar = 'DEVICES_TOO_FAR',
	/** This device is incompatible with multi-array localization group */
	IncompatibleDevice = 'INCOMPATIBLE_DEVICE',
	/** Error connecting to other device(s) */
	ProtocolError = 'PROTOCOL_ERROR'
}

export interface DeviceMultiArrayLocalizationGroupReporter {
	active: boolean;
	groupMembers?: MultiArrayLocalizationGroupMember[];
	missingMembers?: MultiArrayLocalizationGroupMember[];
}

export interface MultiArrayLocalizationGroupMember {
	groupStatus: MultiArrayLocalizationGroupStatus;
	id: string;
}
